export default {
  name: 'CustomStyle',
  mounted() {
    const styleTag = document.createElement('style');
    styleTag.textContent = this.$refs.styles.textContent;
    this.$refs.styles.textContent = null;
    this.$refs.styles.appendChild(styleTag);
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/CustomStyle/component.js